import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Button, ButtonGroup, makeStyles, Popover, MenuItem } from "@material-ui/core";
import AssignmentIcon from '@material-ui/icons/Assignment';
import { TooltipBottom } from "./CustomTooltips";
import CSVReader from "react-csv-reader";
import { CSVLink } from "react-csv";
import t from "../../languages/pl";
import { themeTypeToBool } from './../../utils/helpers';

const useStyles = makeStyles(theme => ({
    csvReader: {
        display: "none"
    },
    buttonGroup: {
        marginRight: 8
    },
    exportFromFile: {
        textDecoration: "none",
        color: themeTypeToBool(theme.palette.type) ? theme.palette.common.black : theme.palette.common.white
    }
}));

const ImportOrExportFileWithTemplate = props => {
    const { onFileLoaded, template, tooltipText, exportCsvHeaders, exportData, exportFilename = 'export.csv' } = props;
    const classes = useStyles();
    const [uploadKey, setUploadKey] = useState(Math.random().toString(36));
    const [anchorEl, setAnchorEl] = useState(null);

    const handleFileLoaded = data => {
        onFileLoaded && onFileLoaded(data);
        setUploadKey(Math.random.toString(36));
    };

    return (
        <React.Fragment>
            <ButtonGroup
                variant="contained"
                color="secondary"
                className={classes.buttonGroup}
            >
                <TooltipBottom title={t.importTemplate}>
                    <Button
                        color="secondary"
                        component={Link}
                        to={template}
                        download={t.template}
                        target="_blank"
                        name="csv"
                    >
                        <AssignmentIcon />
                    </Button>
                </TooltipBottom>
                <CSVReader
                    key={uploadKey}
                    inputId={uploadKey}
                    cssClass={classes.csvReader}
                    accept=".csv"
                    // onError={() => props.notifyError(t.fileUploadError)}
                    onFileLoaded={handleFileLoaded}
                    parserOptions={{
                        header: true,
                        skipEmptyLines: true
                    }}
                />
                <TooltipBottom
                    title={tooltipText}
                >
                    <Button
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                        {t.fromFile}
                    </Button>
                </TooltipBottom>
            </ButtonGroup>
            <Popover
                open={anchorEl !== null}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <MenuItem
                    onClick={() => {
                        document.getElementById(uploadKey).click();
                    }}
                >
                    {t.importFromFile}
                </MenuItem>
                {
                    (exportCsvHeaders && exportData) &&
                    <MenuItem>
                        <CSVLink
                            headers={exportCsvHeaders}
                            data={exportData}
                            filename={exportFilename}
                            target="_blank"
                            className={classes.exportFromFile}
                            separator=";"
                            >
                                {t.exportToFile}
                        </CSVLink>
                    </MenuItem>
                }
            </Popover>
        </React.Fragment>
    );
};

ImportOrExportFileWithTemplate.propTypes = {
    template: PropTypes.node,
    tooltipText: PropTypes.string,
    onFileLoaded: PropTypes.func,
    exportCsvHeaders: PropTypes.array,
    exportData: PropTypes.array,
    exportFilename: PropTypes.string
};

export default ImportOrExportFileWithTemplate;
